const trackEvent = (eventName, value) => {
  if (!!window.rudderanalytics) window.rudderanalytics.track(eventName, value)
}

export default trackEvent
